﻿'use strict';

angular.module('ntmApp').factory('DraggingObject', [function () {

    function DraggingObject() {

        var self = this;
        var draggingObject;

        self.setDraggingObject = function (obj) {
            draggingObject = obj;
        };

        self.isDragging = function (obj) {
            return draggingObject === obj;
        };

        self.releaseDraggingObject = function () {
            draggingObject = undefined;
        };

        self.isDraggingActionActive = function () {
            return draggingObject !== undefined;
        };

        self.getDraggingObject = function () {
            return draggingObject;
        };
    }

    return (DraggingObject);
}]);